export function contains(needles: string | string[], haystack: string[], containsAll: boolean = false): boolean {
    if (typeof needles === 'string') {
        needles = [ needles ];
    }

    if (!needles || !needles.length || !haystack || !haystack.length) {
        return false;
    }

    return containsAll ? needles.every(needle => haystack.includes(needle)) : needles.some(needle => haystack.includes(needle));
}

export function jsonToArray(json: string): string[] {
    if (!json || !json.trim()) {
        return [];
    }

    const parsed = JSON.parse(json) as string[];
    if (!Array.isArray(parsed)) {
        throw new Error('Parsed JSON is not an array');
    }

    return JSON.parse(json) as string[];
}
